// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"267":"5770c467","472":"58b63cd9","577":"bd8086d8","624":"d4aa9c18","660":"d832bc0d","688":"ac65d204","693":"6c6d604f","838":"9e303860","890":"e0193bcc","928":"fe1c7441"}[chunkId] + ".chunk.js";
};